export default __webpack_public_path__ + "static/media/download_black.e1c18cfc.svg";